// extracted by mini-css-extract-plugin
export default {"processMessage":"index_processMessage__OS0PS"};